import { useLocation } from 'react-router';

const useGetArgs = () => {
  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);

  if (!search) {
    return { agrs: {}, urlParams };
  }

  const args = JSON.parse(atob(urlParams.get('args') || ''));

  return { args, urlParams };
};

export default useGetArgs;
